import type { PendingFormEntry } from './assignedForms.types'

export function filterFormRequestSources(
  entries: PendingFormEntry[],
  sources: string[],
): PendingFormEntry[] {
  if (!sources.length) return entries
  return entries
    .map((entry) => {
      const appointments = entry.appointments.filter((group) =>
        sources.includes(group.appointmentId ? 'Appointment' : 'Direct'),
      )
      return {
        ...entry,
        appointments,
        numberOfAppointments: appointments.filter(
          (group) => group.appointmentId,
        ).length,
      }
    })
    .filter((entry) => entry.appointments.length > 0)
}

export function countFormRequests(
  entry: PendingFormEntry,
  status: 'pending' | 'completed',
): number {
  return entry.appointments.reduce((count, group) => {
    const completed =
      group.completedFormsCount ?? group.completedForms?.length ?? 0
    return (
      count +
      (status === 'completed'
        ? completed
        : (group.incompleteForms?.length ??
          Math.max(0, (group.totalFormsCount ?? 0) - completed)))
    )
  }, 0)
}
